import { Box } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { NumberedSectionCard } from '~/shared/ui'

interface ReviewSectionProps {
  locked: boolean
}

/** Step 3: a background-job note before the apply action. */
const ReviewSection = ({ locked }: ReviewSectionProps) => (
  <NumberedSectionCard
    index={3}
    title="Review & apply"
    locked={locked}
    hint="All matched members are included. Each row's current and proposed licensure is shown in the table above; nothing is auto-excluded."
  >
    <Box
      sx={{
        display: 'flex',
        gap: 1.5,
        bgcolor: 'primary.light',
        border: '1px solid',
        borderColor: 'primary.light',
        borderRadius: 2,
        p: 1.5,
        color: 'primary.dark',
        fontSize: 13,
      }}
    >
      <InfoOutlinedIcon sx={{ color: 'primary.main', flexShrink: 0 }} fontSize="small" />
      <Box>
        This runs in the <b>background</b> — you can leave this page while it processes. Large
        panels are updated in batches, so a big reassignment may take a few minutes.
      </Box>
    </Box>
  </NumberedSectionCard>
)

export default ReviewSection
